import React from 'react'
import AnnouncementContainer from '@/src/components/announcements'

const Updates = () => {
  return <AnnouncementContainer category="update" />
}
export default Updates
